module.exports = __webpack_public_path__ + "img/list.7c51fffe.svg";